"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const buildURL = require("./buildURL.cjs");
const buildWidthSrcSet = (url, { widths, ...params }) => {
  return widths.map((width) => {
    return `${buildURL.buildURL(url, { ...params, w: void 0, h: void 0, height: void 0, width })} ${width}w`;
  }).join(", ");
};
exports.buildWidthSrcSet = buildWidthSrcSet;
//# sourceMappingURL=buildWidthSrcSet.cjs.map
